import { IonButton, IonButtons, IonCol, IonRow } from '@ionic/react'
import React from 'react'
import useDeviceMetrics from '../../utilities/useDeviceMetrics'

interface ButtonProps {
  [key: string]: any
}

interface IActionButtonsProps {
  actionButtonObj: ButtonProps[]
}

const ActionButtons: React.FC<IActionButtonsProps> = ({ actionButtonObj }) => {
  const { isTablet } = useDeviceMetrics()
  return (
    <IonRow>
      <IonCol>
        <IonButtons
          className={`action-buttons ${isTablet ? 'ion-float-right w-100' : 'ion-justify-content-center w-100'}`}>
          {actionButtonObj?.map((button) => {
            return (
              <IonButton key={button.label} {...button}>
                {button.label}
              </IonButton>
            )
          })}
        </IonButtons>
      </IonCol>
    </IonRow>
  )
}

export default ActionButtons
